import { useEffect, useState } from "react";
import { HiOutlineChevronUp } from "react-icons/hi";
import PropTypes from "prop-types";
import { backtoTopLabels } from "@/utils/footerUtils";
import Styles from "./index.module.scss";

export default function BackToTop({ topHeight = 0, localeProp = "" }) {
  const handleScrollToTop = () => {
    window.scrollTo({ top: topHeight, behavior: "smooth" });
  };
  const [top, setTop] = useState(true);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const scrollHandler = () => {
      const threshold = 900;
      setVisible(window.scrollY > threshold);
      window.scrollY < 500 ? setTop(false) : setTop(true);
    };

    window.addEventListener("scroll", scrollHandler);

    return () => window.removeEventListener("scroll", scrollHandler);
  }, []);

  return (
    <>
      <button
        className={`fixed bottom-[80px] right-[40px] hidden md:bottom-[60px] md:right-[65px] rounded shadow w-[56px] h-[56px] bg-[#dbdbdb] cursor-pointer pt-[2px] transition-opacity duration-500 ${
          top
            ? "opacity-100 pointer-events-auto"
            : "opacity-0 pointer-events-none"
        }`}
        onClick={handleScrollToTop}
      >
        <div className="font-bold text-[#232323] flex justify-center">
          <HiOutlineChevronUp size={30} />
        </div>
        <div className="text-[8px] font-[helveticaBold,_Helvetica,_sans-serif] font-[600] text-[#232323] text-center">
          {backtoTopLabels}
        </div>
      </button>
      <div className={`${Styles.backTopWrapper} koh-back-top block`}>
        <button
          onClick={handleScrollToTop}
          className={`${visible ? Styles.show : ""}`}
        >
          <span className="icon"></span>
          <p className="text">{backtoTopLabels}</p>
        </button>
      </div>
    </>
  );
}

BackToTop.propTypes = {
  topHeight: PropTypes.number,
  localeProp: PropTypes.string,
};
